import React, { Suspense, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { useSchedulingModule } from '../../module-federation/scheduling-ui';
import { LoadingAppointmentAside } from './LoadingAppointmentAside';

export type AggregatedAvailabilityMFEProps = {
  productName: string;
  primaryLocationId: string;
  locationName: string;
  phoneNumber: string;
};

/**
 * Loads the aggregated availability widget from the independently deployed
 * scheduling-ui MFE.
 *
 * The widget owns the providers query, the booking href and its own loading
 * state; we hand it our `history` so it routes the booking href client-side
 * instead of triggering a full page load.
 */
export const AggregatedAvailabilityMFE = ({
  productName,
  primaryLocationId,
  locationName,
  phoneNumber
}: AggregatedAvailabilityMFEProps) => {
  const [isClient, setIsClient] = useState(false);
  const history = useHistory();

  const AggregatedAvailabilityUiMFE = useSchedulingModule({
    moduleName: 'KyruusAggregatedAvailabilityUI'
  });

  useEffect(() => {
    setIsClient(true);
  }, []);
  if (!isClient || !AggregatedAvailabilityUiMFE) {
    return null;
  }

  return (
    <Suspense fallback={<LoadingAppointmentAside isLoading={true} />}>
      <AggregatedAvailabilityUiMFE
        productName={productName}
        primaryLocationId={primaryLocationId}
        locationName={locationName}
        phoneNumber={phoneNumber}
        setDefaultPurpose={true}
        history={history}
      />
    </Suspense>
  );
};

export default AggregatedAvailabilityMFE;
